<template>
  <v-snackbar
    v-model="show"
    :timeout="-1"
    color="primary"
    top
    center
    elevation="6"
  >
    {{ $t('newVersionAvailable') }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="reload">
        <v-icon small left class="mr-1">
          mdi-reload
        </v-icon>
        {{ $t('reload') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'VersionUpdateBanner',

  computed: {
    ...mapGetters('version', ['updateAvailable']),
    show: {
      get () { return this.updateAvailable },
      set () { }
    }
  },

  methods: {
    ...mapActions('version', ['reloadApp']),
    reload () {
      this.reloadApp()
    }
  }
}
</script>
